import React from 'react'

import Icon from 'Pods/Shared/Icon/Icon'

import iconDrag from 'images/publisher/icons-drag.jpg'
import iconPreview from 'images/publisher/icons-preview.jpg'
import iconInfo from 'images/publisher/icons-info.jpg'
import iconSell from 'images/publisher/icons-sell.jpg'

class Wizard extends React.Component {
  constructor() {
    super()

    this.state = { isOpen: !sessionStorage.getItem('batchUploaderWizardClosed') }

    this.triggerWizard = this.triggerWizard.bind(this)
  }

  triggerWizard() {
    sessionStorage.setItem('batchUploaderWizardClosed', 'true');

    this.setState({ isOpen: !this.state.isOpen })
  }

  render() {
    return (
      <div>
        {this.state.isOpen ? (
          <div className="card wizard-container">
            <div className="l-inner wizard-container_inner">
              <button className="btn btn-transparent btn-close" onClick={this.triggerWizard}>
                <Icon type={['fal', 'times']} color="grey-dark" notSpaced />
              </button>
              <div className="section__title">Batch uploads have never been easier!</div>
              <p className="text-default">
                Hi there first time user! This is how our batch upload process works. Do not forget
                to pay special attention to your file structure.
              </p>
              <div className="row u-text-center wizard__icons">
                <div className="col-12 col-sm-6 col-md-3 wizard__icon-container">
                  <span className="fa-layers fa-fw fa-4x">
                    <img src={iconDrag} alt="Drag and drop your batch folder" />
                  </span>
                  <div className="text-dark text-semibold u-mt10">Drag and drop your batch folder</div>
                  <Icon type={['far', 'chevron-right']} notSpaced />
                </div>
                <div className="col-12 col-sm-6 col-md-3 wizard__icon-container">
                  <span className="fa-layers fa-fw fa-4x">
                    <img src={iconPreview} alt="Preview the upload structure" />
                  </span>
                  <div className="text-dark text-semibold u-mt10">Preview the upload structure</div>
                  <Icon type={['far', 'chevron-right']} notSpaced />
                </div>
                <div className="col-12 col-sm-6 col-md-3 wizard__icon-container">
                  <span className="fa-layers fa-fw fa-4x">
                    <img src={iconInfo} alt="Add info and edit each model" />
                  </span>
                  <div className="text-dark text-semibold u-mt10">Add info and edit each model</div>
                  <Icon type={['far', 'chevron-right']} notSpaced />
                </div>
                <div className="col-12 col-sm-6 col-md-3 wizard__icon-container">
                  <span className="fa-layers fa-fw fa-4x">
                    <img src={iconSell} alt="Publish and start selling" />
                  </span>
                  <div className="text-dark text-semibold u-mt10">Publish and start selling</div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="u-text-right link--primary-dark wizard-trigger" onClick={this.triggerWizard}>How it works</div>
        )}
      </div>
    )
  }
}

export default Wizard
